import '@fontsource/russo-one/400.css';
import '@fontsource/rubik/500.css';
import '@fontsource/rubik/700.css';
import { Game } from './game/game';
import { loadBoxerModel } from './view/boxer/bodyModel';

async function start(): Promise<void> {
  // Textures drawn with the game's font must wait for it, or they come out in a fallback face.
  const [model] = await Promise.all([loadBoxerModel(), document.fonts.load('400 64px "Russo One"'), document.fonts.load('700 32px Rubik')]);
  const canvas = document.querySelector<HTMLCanvasElement>('#scene')!;
  const game = new Game(canvas, document.querySelector<HTMLElement>('#hud')!, model);
  await game.warmUp();
  game.start();
  // Away once the first picture is on the screen.
  const loader = document.querySelector<HTMLElement>('#loader')!;
  requestAnimationFrame(() => requestAnimationFrame(() => loader.classList.add('done')));
  loader.addEventListener('transitionend', () => loader.remove());

  // Looking inside and stepping by hand while developing, for pictures taken when the browser draws no frames itself.
  if (import.meta.env.DEV) {
    const advance = (seconds: number) => {
      for (let t = 0; t < seconds; t += 1 / 60) game.frame(1 / 60);
    };
    Object.assign(window, {
      game,
      advance,
      snapshot: async (name: string, seconds = 0) => {
        advance(seconds);
        game.frame(1 / 60);
        await fetch(`/__snapshot?name=${name}`, { method: 'POST', body: canvas.toDataURL('image/jpeg', 0.88) });
      },
    });
  }
}

void start();
